import React from "react";
import { useDisclosure } from "@chakra-ui/react";

import { useAccessibleButtonComponent } from "@hooks";
import { BaseModal } from "./BaseModal";

interface IClickableComponentModal {
  ClickableComponent: ({ ...delegated }) => JSX.Element;
  title: string;
}

export function ClickableComponentModal({
  title,
  ClickableComponent,
  children,
}: React.PropsWithChildren<IClickableComponentModal>) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const clickProps = useAccessibleButtonComponent(onOpen, isOpen);
  return (
    <>
      <ClickableComponent {...clickProps} />
      <BaseModal isOpen={isOpen} onClose={onClose} title={title}>
        {children}
      </BaseModal>
    </>
  );
}
